import React from "react";

import { Select, MenuItem } from "@mui/material";

const Select2 = ({ options, label, onSelect }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <span>{label}</span>
      <Select
        className="material-ui-select"
        options={options}
        getOptionLabel={(option) => option.title}
        style={{ width: 200 }}
        onChange={(ev) => onSelect(ev.target.value)}
        noOptionsText="Opção não encontrada"
      >
        {options.map((option, idx) => (
          <MenuItem className="blue-text" key={idx} value={option.value}>
            {option.title}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default Select2;
